import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface DuplicateLeadCardState {
  isSelectionMode: boolean;
  selectedLeadIds: (string | number)[];
  isDeleteConfirmationModalOpen: boolean;
  searchTerm: string;
  currentPage: number;
}

const initialState: DuplicateLeadCardState = {
  isSelectionMode: false,
  selectedLeadIds: [],
  isDeleteConfirmationModalOpen: false,
  searchTerm: "",
  currentPage: 1,
};

const duplicateLeadCardSlice = createSlice({
  name: "duplicateLeadCard",
  initialState,
  reducers: {
    setIsSelectionMode: (state, action: PayloadAction<boolean>) => {
      state.isSelectionMode = action.payload;
    },
    toggleLeadSelection: (state, action: PayloadAction<string | number>) => {
      const id = action.payload;
      if (state.selectedLeadIds.includes(id)) {
        state.selectedLeadIds = state.selectedLeadIds.filter((x) => x !== id);
      } else {
        state.selectedLeadIds.push(id);
      }
    },
    clearSelectedLeadIds: (state) => {
      state.selectedLeadIds = [];
    },
    selectAllLeads: (state, action: PayloadAction<(string | number)[]>) => {
      state.selectedLeadIds = action.payload;
    },
    setIsDeleteConfirmationModalOpen: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isDeleteConfirmationModalOpen = action.payload;
    },
    setDuplicateSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
      state.currentPage = 1;
    },
    setDuplicateCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    resetDuplicatePanel: (state) => {
      state.isSelectionMode = false;
      state.selectedLeadIds = [];
      state.isDeleteConfirmationModalOpen = false;
      state.searchTerm = "";
      state.currentPage = 1;
    },
  },
});

export const {
  setIsSelectionMode,
  toggleLeadSelection,
  clearSelectedLeadIds,
  selectAllLeads,
  setIsDeleteConfirmationModalOpen,
  setDuplicateSearchTerm,
  setDuplicateCurrentPage,
  resetDuplicatePanel,
} = duplicateLeadCardSlice.actions;
export default duplicateLeadCardSlice.reducer;
